import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { RadioButtonModule } from '@syncfusion/ej2-angular-buttons';
import { NumericTextBoxModule, NumericTextBoxAllModule } from '@syncfusion/ej2-angular-inputs';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';
import { PayerRoutingModule } from './payer-routing.module';
import { PhoneNumberFormatService } from 'src/app/phone-number-format.service';
import { PayerComponent } from './payer.component';
@NgModule({
  declarations: [PayerComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    RadioButtonModule,
    NumericTextBoxModule,
    NumericTextBoxAllModule,
    NgSelectModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    PayerRoutingModule
  ],
  providers: [ColumnChooserService ,PhoneNumberFormatService,PageService,SortService,FilterService, ResizeService],
})
export class PayerModule { }
